import * as React from 'react'

import ParentMonthlyReserveListPresenter from './presenter'
import { getMonthlyReserve } from '@/apis/reserves'

interface IProps {
  userId: number
  currentYear: number
  currentMonth: number
  reserves: IReserveSummary[]
}

export const ParentMonthlyReserveList = (props: IProps): JSX.Element => {
  const [reserves, setReserves] = React.useState(props.reserves)
  const [year, setYear] = React.useState(props.currentYear)
  const [month, setMonth] = React.useState(props.currentMonth)
  const [showYear, setShowYear] = React.useState(props.currentYear)
  const handleClick = async (month: number) => {
    const result = await getMonthlyReserve(showYear, month)

    if (result.result) {
      setReserves(result.res)
      setMonth(month)
      setYear(showYear)
    }
  }

  return (
    <ParentMonthlyReserveListPresenter
      reserves={reserves}
      currentMonth={month}
      currentYear={year}
      showYear={showYear}
      monthClickhandler={handleClick}
      yearClickhandler={setShowYear}
    />
  )
}

export default ParentMonthlyReserveList
